// extracted by mini-css-extract-plugin
export default {"page_content":"pageContent_page_content__AY0GR","report_page_content":"pageContent_report_page_content__+vOBI"};